export const LOADING = 'loading';
export const SUCCESS = 'success';
export const FAILURE = 'failure';
export const WAIT = 'wait';

export const LOGGED_OUT = 'logged_out';
